export enum SuppliesSubscriptionOrderInterval {
  Week = "week",
  Month = "month",
}
